<template>
  <div class="game">
    <div class="h-banner">
      <div class="container">
        <h1>云渲染解决方案</h1>
        <div class="row">
          <p class="col-sm-7">云渲染训练解决方案是面向影视视效、三维动画、设计效果等场景提供的分布式渲染农场解决方案，提供海量GPU算力，兼容主流设计软件。</p>
        </div>
      </div>
    </div>
    <div class="session-1">
      <div class="container">
        <div class="row"><div class="caption">方案优势</div></div>
        <ul class="row">
          <li class="col-md-6 col-sm-12 col-xs-12">
            <div class="li-wrap">
              <img src="@/assets/images/scheme/r_rendering_icon_01.png" alt="">
              <div class="des">
                <div class="title">海量高性能渲染资源</div>
                <div class="txt">海量的渲染GPU资源池，可以灵活伸缩使用，节点可动态无限拓展，大幅提高设计师工作效率。</div>
              </div>
            </div>
          </li>
          <li class="col-md-6 col-sm-12 col-xs-12">
            <div class="li-wrap">
              <img src="@/assets/images/scheme/r_rendering_icon_02.png" alt="">
              <div class="des">
                <div class="title">提升渲染效率</div>
                <div class="txt">通过GPU算力堆叠和高效的网络传输，大大提高了渲染效率，由几个月或几天的渲染时间缩减到几小时。</div>
              </div>
            </div>
          </li>
          <li class="col-md-6 col-sm-12 col-xs-12">
            <div class="li-wrap">
              <img src="@/assets/images/scheme/r_rendering_icon_03.png" alt="">
              <div class="des">
                <div class="title">数据安全保障</div>
                <div class="txt">全链路数据安全传输及管控，数据存储通过专业加密，全程宝藏数据可靠安全。</div>
              </div>
            </div>
          </li>
          <li class="col-md-6 col-sm-12 col-xs-12">
            <div class="li-wrap">
              <img src="@/assets/images/scheme/r_rendering_icon_04.png" alt="">
              <div class="des">
                <div class="title">7x24全程服务</div>
                <div class="txt">专业渲染工程师定制最佳渲染方案，24h为客户项目保驾护航，更加安全可靠。</div>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </div>
    <div class="session-2">
      <div class="container">
        <div class="box">
          <div class="row"><div class="caption">应用场景</div></div>
          <div class="row">
            <p class="des col-lg-8">云蜂树智渲染为电影工作者、艺术家和设计师创意群体量身打造，通过按需渲染让您更快地投入生产。强大的按需渲染、无需高配置硬件，无需专业人员运维，一键点击即可渲染，无需运维，使用便捷，支持多种软件与插件、灵活的渲染农场定价、专属服务团队、数据安全保密。</p>
          </div>
          <div class="visible-lg-block tags">
            <ul>
              <li>电影工作者</li>
              <li>艺术家</li>
              <li>设计师</li>
              <li>创意人士</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <div class="session-3">
      <div class="container">
        <div class="row"><div class="caption">支持的软件</div></div>
        <div class="row">
          <ul>
            <li class="col-md-2 col-sm-4 col-xs-6">
              <div class="li-wrap">
                <img src="@/assets/images/scheme/r_rendering_icon_05.png" alt="">
              </div>
            </li>
            <li class="col-md-2 col-sm-4 col-xs-6">
              <div class="li-wrap">
                <img src="@/assets/images/scheme/r_rendering_icon_06.png" alt="" style="width:33%">
              </div>
            </li>
            <li class="col-md-2 col-sm-4 col-xs-6">
              <div class="li-wrap">
                <img src="@/assets/images/scheme/r_rendering_icon_07.png" alt="">
              </div>
            </li>
            <li class="col-md-2 col-sm-4 col-xs-6">
              <div class="li-wrap">
                <img src="@/assets/images/scheme/r_rendering_icon_08.png" alt="">
              </div>
            </li>
            <li class="col-md-2 col-sm-4 col-xs-6">
              <div class="li-wrap">
                <img src="@/assets/images/scheme/r_rendering_icon_10.png" alt="">
              </div>
            </li>
            <li class="col-md-2 col-sm-4 col-xs-6">
              <div class="li-wrap">
                <img src="@/assets/images/scheme/r_rendering_icon_09.png" alt="">
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.h-banner{
  background: #282839;
  color: #fff;
  h1{
    font-size: 36px;
    font-weight: bold;
    margin-top: 70px;
  }
  p{
    font-size: 18px;
    color: #A2A2BB;
    margin-top: 20px;
    margin-bottom: 70px;
  }
}
.caption{
  margin-top: 80px;
}
@media (max-width: $screen-sm-min) {
  .caption{
    margin-top: 40px;
  }
}
.session-1{
  .caption{
    margin-bottom: 0;
  }
  ul{
    li{
      margin-top: 60px;
      .li-wrap{
        display: flex;
        img{
          display: block;
          width: 80px;
          height: 80px;
        }
        .des{
          margin-left: 20px;
          .title{
            font-size: 18px;
            font-weight: bold;
          }
          .txt{
            font-size: 14px;
            margin-top: 9px;
          }
        }
      }
    }
  }
}
.session-2{
  .des{
    font-size: 14px;
  }
}
@media (min-width: $screen-lg-min) {
  .session-2{
    padding: 20px 0;
    margin-top: 100px;
    .box{
      position: relative;
      background: url('../../assets/images/scheme/r_rendering_images_01.png') no-repeat;
      background-size: cover;
      height: 420px;
      padding-left: 30px;
      .caption{
        color: #fff;
        margin-top: 252px;
      }
      .des{
        color: #fff;
      }
      .tags{
        position: absolute;
        top: 20px;
        left: 0;
        right: 0;
        ul{
          display: flex;
          justify-content: space-between;
          li{
            color: #fff;
            font-size: 20px;
            font-weight: bold;
            flex: 1;
            margin-left: 20px;
          }
        }
      }
    }
  }
}
.session-3{
  margin-bottom: 120px;
  .container{
    .caption{
      margin-bottom: 10px;
    }
    ul{
      li{
        position: relative;
        margin-top: 30px;
        .li-wrap{
          box-shadow: 0px 2px 18px 0px rgba(122, 132, 165, 0.26);
          padding-bottom: 100%;
          border-radius: 24px;
          img{
            position: absolute;
            left: 50%;
            top: 50%;
            transform: translate(-50%, -50%);
            width: 50%;
          }
        }
      }
    }
  }
}
@media (max-width: $screen-sm-min) {
  .session-3{
    margin-bottom: 40px;
  }
}
</style>
